/**
 * Welk onderdeel van de webapp open staat, voor het weekoverzicht "wie
 * gebruikte wat, wanneer" in de beheerconsole (15-10-2026). Alleen de
 * onderdelen die iets zeggen over waarvoor het platform gebruikt wordt;
 * kijken naar video's en playlists wordt al apart vastgelegd.
 *
 * De namen moeten overeenkomen met PAGINA_SOORTEN in siq_videos
 * (monitoring/gebruik-week.ts) en arch (MonitoringController).
 */
export type GebruikOnderdeel = 'stats' | 'report' | 'match' | 'live' | 'players' | 'tagger';

export interface GebruikPlek {
  area: GebruikOnderdeel;
  ref: string;
}

const GEEN_WEDSTRIJD = new Set(['add', 'league']);

export function onderdeelVan(url: string): GebruikPlek | null {
  const pad = (url ?? '').split(/[?#]/)[0];
  const d = pad.split('/').filter(Boolean);
  if (!d.length) {
    return null;
  }
  switch (d[0]) {
    case 'matches': {
      const id = d[1];
      if (!id || GEEN_WEDSTRIJD.has(id)) {
        return null;
      }
      if (d[2] === 'stats' || d[2] === 'advanced') {
        return { area: 'stats', ref: id };
      }
      if (d[2] === 'rapport') {
        return { area: 'report', ref: id };
      }
      return { area: 'match', ref: id };
    }
    case 'live':
      return { area: 'live', ref: d[1] ?? '' };
    case 'players':
      return { area: 'players', ref: d[1] ?? '' };
    case 'search':
      return d[1] === 'speler' ? { area: 'players', ref: d[2] ?? '' } : null;
    case 'tagging':
      return { area: 'tagger', ref: '' };
    default:
      return null;
  }
}
